// formFields.js
export const formFields = [
  {
    section: "From(Header)",
    name: "dtlAl1AccumulationCodeLst",
    label: "List",
    fieldLabel: "List",
    type: "text",
    options: {},
    fieldNature: "Add:Read-Only",
    position: [5, 22],
  },
  {
    section: "From(Header)",
    name: "dtlAl1AccumCodeListDescr",
    label: "Description",
    fieldLabel: "Description",
    type: "text",
    options: {},
    fieldNature: "Add:Read-Only",
    position: [6, 22],
  },
  {
    section: "To(Header)",
    name: "dtlAccumulationCodeList",
    label: "List",
    fieldLabel: "List",
    type: "lookup",
    externalProgram: { default: "RCAL1005" },
    params: {
      lookupType: "local",
      fieldMapping: {
        default: [
          {
            source: "dtlAccumulationCodeList",
            target: "al1AccumulationCodeLst",
          },
          { source: "dtlAccumCodeListDescr", target: "al1AccumCodeListDescr" },
        ],
      },
    },
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add:Editable",
    position: [9, 22],
  },
  {
    section: "To(Header)",
    name: "dtlAccumCodeListDescr",
    label: "Description",
    fieldLabel: "Description",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 25, message: "MAXLENGTH_25" },
    },
    fieldNature: "Add:Editable",
    position: [10, 22],
  },
];

// screenInfo.js
export const screenInfo = {
  screenTitle: "Copy/Merge Accumulation Code List",
  screenNumber: "RCAL1004",
};
// required: { value: true, message: 'REQUIRED' },
// required: { value: true, message: 'REQUIRED' },
